import { PATH_NAME } from "../configs/pathName";
import { ICollection, IProduct } from "../models/ICollection";
import axiosInstance from "./axiosInstance";

export const getCollections = async () : Promise<ICollection[]> => {
  const response = await axiosInstance.get(PATH_NAME.API_GET_COLLECTION);
  return response.data.result.items;
}

export const getCollectionById = async (id: string) => {
  const response = await axiosInstance.get<{
      result: any; collection: ICollection; products: IProduct[] 
  }>(PATH_NAME.API_GET_COLLECTION_BY_ID(id));
  return response.data;
};

export const getCollectionBySlug = async (slug: string) => {
  const response = await axiosInstance.get<{
      result: any; collection: ICollection; products: IProduct[] 
  }>(PATH_NAME.API_GET_COLLECTION_BY_SLUG(slug));
  return response.data;
};